import { AgentSession, AgentMessage, AgentMessageRequest } from '../Types/bizagent';
import { get, post, httpDelete, getQSFromObject } from './common';

const bizAgentEndpoint = 'api/bizagent';

export async function createSession(configSystemName: string) {
	const queryString = getQSFromObject({ configSystemName });
	const endpoint = `${bizAgentEndpoint}/session?${queryString}`;
	const result = await post<AgentSession>(endpoint, {});
	return result;
}

export async function getSession(sessionId: string) {
	const endpoint = `${bizAgentEndpoint}/session/${sessionId}`;
	const result = await get<AgentSession>(endpoint);
	return result;
}

export async function sendMessage(request: AgentMessageRequest) {
	const endpoint = `${bizAgentEndpoint}/message`;
	const result = await post<AgentMessage>(endpoint, request);
	return result;
}

export async function sendMessageAndFetchResponseAsStream(
	request: AgentMessageRequest,
	onChunk: (chunk: string) => void,
	onComplete: () => void
) {
	const endpoint = `${bizAgentEndpoint}/message/stream`;
	const result = await post(endpoint, request, onChunk, onComplete);
	return result;
}

export async function getMessageHistory(sessionId: string) {
	const endpoint = `${bizAgentEndpoint}/history/${sessionId}`;
	const result = await get<AgentMessage[]>(endpoint);
	return result;
}

export async function clearSessionHistory(sessionId: string) {
	const endpoint = `${bizAgentEndpoint}/history/${sessionId}`;
	const result = await httpDelete<{ success: boolean }>(endpoint);
	return result;
}

export async function deleteSession(sessionId: string) {
	const endpoint = `${bizAgentEndpoint}/session/${sessionId}`;
	const result = await httpDelete<{ success: boolean }>(endpoint);
	return result;
}
